import React, { Fragment } from "react";
import { connect } from "react-redux";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MaterialDataTable from "material-table/Table.js";
import {
  crudActions,
  confirmActions,
  modalActions,
  loaderActions,
} from "../../../_actions";
import { fileService } from "../../../_services/file.service";
import { TableAction } from "../../../material-table/TableAction";
import { PermissionHelper } from "_helpers";
import UpdatePriceForm from "pages/JobSeekerModule/JobSeeker/View";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import IconButton from "@material-ui/core/IconButton";
import { Button } from "antd";

const title = "Job Seeker";
class JobSeekerList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.deleteCrud = this.deleteCrud.bind(this);
    this.addCrud = this.addCrud.bind(this);
    this.editCrud = this.editCrud.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
    this.viewCrud = this.viewCrud.bind(this);
  }

  componentDidUpdate() {
    if (this.props.confirm.confirm) {
      if (this.props.confirm.data.length) {
        const ids = this.props.confirm.data.map((value) => value.id);
        this.props.deleteAllCrud("form", "jobseekers/delete_all", {
          ids: JSON.stringify(ids),
        });
      } else {
        if (this.props.confirm.data.id) {
          this.deleteData(this.props.confirm.data.id);
        }
      }
      this.props.clearConfirm();
    }
  }
  toggleModal(log) {
    this.props.openModal({
      open: true,
      component: log,
    });
  }

  deleteData = (id) => {
    this.props.deleteCrud("form", "jobseekers", id);
  };

  deleteCrud(data) {
    this.props.showConfirm(
      "Confirm",
      `Are you sure want to delete ${data.first_name} ?`,
      data
    );
  }

  deleteAll(data) {
    this.props.showConfirm(
      "Confirm",
      `Are you sure want to delete ${data.length} row ?`,
      data
    );
  }

  editCrud(data) {
    this.props.history.push(`/admin/jobseekers-form/${data.id}`);
  }

  upDateCrud = (data) => {
    this.props.openModal({
      open: true,
      title: "Update Resume Price",
      component: (
        <UpdatePriceForm
          id={data.id}
          actionFor="user"
          resumePrice={data.resume.price}
        />
      ),
    });
  };
  viewCrud(data) {
    const { resume } = data;
    if (resume && resume.file_path) {
      if (resume.file_path.endsWith(".pdf")) {
        this.props.openModal({
          open: true,
          component: (
            <iframe
              src={resume.file_path}
              title="PDF Viewer"
              style={{ width: "100%", height: "600px", border: "none" }}
            />
          ),
        });
      } else {
        this.props.openModal({
          open: true,
          component: (
            <img
              src={resume.file_path}
              alt="Resume"
              style={{ maxWidth: "100%", maxHeight: "80vh" }}
            />
          ),
        });
      }
    } else {
      console.log("File path is not available");
      return null;
    }
  }

  addCrud() {
    this.props.history.push(`/admin/jobseekers-form/new`);
  }
  export = () => {
    fileService._download("reports/jobseekerreport");
  };
  render() {
    const columns = [
      {
        title: "Job Seeker Name",
        field: "first_name",
        render: (rowData) => `${rowData.first_name} ${rowData.last_name}`,
      },
      {
        title: "Image",
        field: "image",
        filtering: false,
        render: (item) => <img src={item.image} alt="jobseeker" width="50%" />,
      },
      {
        title: "Experience",
        field: "years_of_experience",
        render: (rowData) => `${rowData.years_of_experience} Years`,
      },
      {
        title: "Skills",
        field: "skills[0].name",
      },
      {
        title: "Mobile",
        field: "mobile",
      },
      {
        title: "Email",
        field: "email",
      },
      {
        title: "Price",
        field: "resume.price",
        render: (rowData) => `${rowData.resume?.price ?? 0} USD`,
      },
      {
        title: "Created Date",
        field: "created_at",
        defaultSort: "desc",
      },
      TableAction(
        PermissionHelper.checkPermission("delete_consultant")
          ? this.deleteCrud
          : null,
        PermissionHelper.checkPermission("edit_cron_job")
          ? this.editCrud
          : null,
        false,
        false,
        false,
        ({ rowData }) => (
          <Fragment>
            {
              <IconButton
                aria-label="custom"
                onClick={() => this.upDateCrud(rowData)}
              >
                <AttachMoneyIcon fontSize="small" />
              </IconButton>
            }
          </Fragment>
        ),
        ({ rowData }) => {
          return (
            <Fragment>
              {rowData.status === 1 ? (
                <Fragment>
                  <Button
                    style={{ marginTop: "8px" }}
                    type="primary"
                    danger
                    onClick={() => {
                      this.props.deactivateJobSeeker(
                        "ACTIVATE",
                        `jobseekers/deactive/${rowData.id}`,
                        {
                          status: "Deactivated",
                        }
                      );
                    }}
                  >
                    Deactivate
                  </Button>
                </Fragment>
              ) : (
                <Button
                  type="primary"
                  onClick={() => {
                    this.props.activateJobSeeker(
                      "ACTIVATE",
                      `jobseekers/active/${rowData.id}`
                    );
                  }}
                >
                  Active
                </Button>
              )}
            </Fragment>
          );
        }
      ),
    ];

    return (
      <GridContainer>
        <GridItem xs={12}>
          <MaterialDataTable
            title={title}
            columns={columns}
            addData={
              PermissionHelper.checkPermission("add_cron_job")
                ? this.addCrud
                : false
            }
            deleteAll={
              PermissionHelper.checkPermission("delete_consultant")
                ? this.deleteAll
                : false
            }
            url="jobseekers"
            selection={true}
            grouping={false}
            defaultExpanded={true}
            refresh={true}
            serverSide={true}
            search={true}
            sorting={true}
            filtering={true}
            export={
              PermissionHelper.checkPermission(
                "export_consultant_payout_reports"
              )
                ? this.export
                : false
            }
          />
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { authentication, confirm } = state;
  const { user } = authentication;
  return { user, confirm };
};

const actionCreators = {
  getRole: crudActions._get,
  deleteCrud: crudActions._delete,
  deleteAllCrud: crudActions._deleteAll,
  showConfirm: confirmActions.show,
  clearConfirm: confirmActions.clear,
  openModal: modalActions.open,
  showLoader: loaderActions.show,
  hideLoader: loaderActions.hide,
  activateJobSeeker: crudActions._create,
  deactivateJobSeeker: crudActions._create,
};

export default connect(
  mapStateToProps,
  actionCreators
)(JobSeekerList);
